/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamCorrectionExampublishid200,
  GetApiV1ExamCorrectionExampublishid400,
  GetApiV1ExamCorrectionExampublishid401,
  GetApiV1ExamCorrectionExampublishid500,
  GetApiV1ExamCorrectionExampublishidPathParams,
  GetApiV1ExamCorrectionExampublishidQueryResponse,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionExampublishid.ts";
import { examItemAnswerTextCorrectionGridDetailViewModelSchema } from "../examItemAnswerTextCorrectionGridDetailViewModelSchema.ts";

export const getApiV1ExamCorrectionExampublishidPathParamsSchema = z.object({
  examPublishId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamCorrectionExampublishidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamCorrectionExampublishid200Schema = z.lazy(
  () => examItemAnswerTextCorrectionGridDetailViewModelSchema,
) as unknown as ToZod<GetApiV1ExamCorrectionExampublishid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamCorrectionExampublishid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionExampublishid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamCorrectionExampublishid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionExampublishid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamCorrectionExampublishid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamCorrectionExampublishid500>;

export const getApiV1ExamCorrectionExampublishidQueryResponseSchema = z.lazy(
  () => getApiV1ExamCorrectionExampublishid200Schema,
) as unknown as ToZod<GetApiV1ExamCorrectionExampublishidQueryResponse>;
